import { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { Lock } from "lucide-react";
import { mediaUrl } from "../config";

// Preview player for a locked paid episode. Plays the server's truncated
// preview file (lock.previewUrl) — the locked part is a separate file the
// viewer never receives, so it cannot be watched by skipping or any workaround.
// When the preview ends, onLocked fires and the paywall appears.
const GatedPlayer = ({ video, className = "", onLocked }) => {
  const ref = useRef(null);
  const [preparing, setPreparing] = useState(false);
  const previewUrl = video?.lock?.previewUrl;

  useEffect(() => {
    const el = ref.current;
    if (!el || !previewUrl) return;
    setPreparing(false);
    const src = mediaUrl(previewUrl);
    const isHls = src.includes(".m3u8");
    let hls;
    if (isHls) {
      if (el.canPlayType("application/vnd.apple.mpegurl")) el.src = src;
      else if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(el);
      } else setPreparing(true);
    } else {
      el.src = src;
    }
    return () => { if (hls) hls.destroy(); };
  }, [video, previewUrl]);

  if (!previewUrl || preparing) {
    return (
      <div className={`relative flex items-center justify-center overflow-hidden bg-surface ${className}`} data-testid="player-preparing">
        {mediaUrl(video?.thumbnail) && <img src={mediaUrl(video.thumbnail)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />}
        <p className="relative font-heading text-sm font-semibold text-white">Getting ready…</p>
      </div>
    );
  }

  return (
    <video
      ref={ref}
      controls
      playsInline
      autoPlay
      poster={mediaUrl(video?.thumbnail) || undefined}
      onEnded={() => onLocked && onLocked()}
      className={`bg-black ${className}`}
      data-testid="video-player"
    />
  );
};

export const LockedOverlay = ({ title }) => (
  <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-black/85 text-center" data-testid="locked-overlay">
    <Lock size={28} className="text-crimson" />
    <p className="mt-3 font-heading text-base font-bold text-white">Preview ended</p>
    <p className="mt-1 text-sm text-slate-400">Pay to keep watching {title ? `“${title}”` : "this series"}.</p>
  </div>
);

export default GatedPlayer;
